import { useMemo } from 'react';
import { useTheme } from '@/components/theme/useTheme';

/**
 * Theme-aware Recharts palette (86d3peur0 Phase C) — resolves the semantic CSS-var HSL triplets to
 * `hsl(...)` strings and recomputes on theme change, so charts stay correct across Light / Dark / Industrial.
 * Copied from the mro-dashboard hook (kept feature-local to avoid coupling the two dashboards).
 */
export function useChartColors() {
  const { resolvedTheme } = useTheme();

  return useMemo(() => {
    const v = (name: string) =>
      `hsl(${getComputedStyle(document.documentElement).getPropertyValue(name).trim()})`;

    return {
      info: v('--info'),
      success: v('--success'),
      warning: v('--warning'),
      destructive: v('--destructive'),
      muted: v('--muted-foreground'),
      border: v('--border'),
      foreground: v('--foreground'),
      card: v('--card'),
      primary: v('--primary'),
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resolvedTheme]);
}
